// extracted by css-extract-rspack-plugin
var _1 = "BreakerTypeIcon-m_breakerIcon-qiAO9h9r";
var _2 = "BreakerTypeIcon-m_invert-dMaBrbqF";
export { _1 as "breakerIcon", _2 as "invert" }
